<template>
    <div class="process-line-box">
        <div class="rocess-line-start">
            <div class="rocess-line-start-ring"></div>
            <!-- <div class="rocess-line">

            </div> -->
            <div class="arrow-body">
                <div class="flow-body"></div>
            </div>
        </div>
        <div class="rocess-line-node" v-for="(item,index) in dataList" :key="index">
            <div class="node-item">
                <div class="rocess-line-node-item">
                    <div class="left-icon">
                        <img :src="jinxingzhong"  v-if="item.nodeState===1"/>
                        <img :src="yq"  v-if="item.nodeState===0"/>
                        <img :src="yiwancheng"  v-if="item.nodeState===2"/>
                        <img :src="yiyanqi"  v-if="item.nodeState===3"/>
                    </div>
                    <div class="process-desc">
                        <!-- {{ item.nodeName }}   -->
                    </div>
                </div>
                <div class="node-master">
                    <div class="tit">
                        <template v-if="item.childProcess === 0">
                            {{ item.nodeName }}
                        </template>
                        <template v-if="item.childProcess === 1">
                           <span class="approvalProcess" @click="showChildProcess(item)">{{ item.nodeName }}</span> 
                        </template>
                        <template v-if="item.childProcess === 2">
                            <span class="businessProcess" @click="showChildProcess(item)">{{ item.nodeName }}</span> 
                        </template>
                    </div>
                    <div class="user">
                        <div class="surname">{{ item.masterUserName.substring(0,1) }}</div>
                        <div class="fullname">{{ item.masterUserName }}</div>
                    </div>
                    <div class="processIngdesc processIng"  v-if="item.nodeState === 1">
                        {{ item.nodeProcessDesc }}
                    </div>
                    <div class="processIngdesc processComplete"  v-else-if="item.nodeState === 2">
                        {{ item.nodeProcessDesc }}
                    </div>
                    <div class="processIngdesc"  v-else>
                        {{ item.nodeProcessDesc }}
                    </div>
                </div>
                <div class="node-name">
                     <div class="node-name-icon">
                        <img :src="flagWc" v-if="item.nodeState===2"/>
                        <img :src="flagImg" v-else/>
                     </div>
                     <div class="node-name-title">
                        {{ item.nodeProcessDesc }}
                     </div>
                </div>
            </div>
            <!-- <div class="rocess-line"></div> -->
            <div class="arrow-body">
                <div class="flow-body"></div>
            </div>
        </div>
        <div class="rocess-line-end">
            <div class="rocess-line-end-ring"></div>
        </div>
        <el-dialog
            width="95%"
            top="1vh"
            :fullscreen=true
            :visible.sync="isShowProcessMaps"
            append-to-body>
            <ProcessMaps :processList="processMapsArray"></ProcessMaps>
        </el-dialog>
        <el-dialog
            width="95%"
            top="1vh"
            :fullscreen=true
            :visible.sync="isShowApproveMaps"
            append-to-body>
            <ApproveMaps :processList="approveMapsArray"></ApproveMaps>
        </el-dialog>
    </div>
</template>

<script>
  import ProcessMaps from './ProcessMaps.vue';
  export default {
      components: {
          'ApproveMaps': ProcessMaps,
          'ProcessMaps': ProcessMaps
      },
      data () {
          return {
              testName: '天黑大帅哥',
              yq: require('@/assets/img/process/yanqi.png'),
              yiwancheng: require('@/assets/img/process/yiwancheng.png'),
              jinxingzhong: require('@/assets/img/process/jinxingzhong.png'),
              yiyanqi: require('@/assets/img/process/yiyanqi.png'),
              flagImg: require('@/assets/img/process/flag.png'),
              flagWc: require('@/assets/img/process/flag_wc.png'),
              dataList: [
                  {
                      nodeName: '业务立项',
                      beginDate: '2023-06-06',
                      endDate: '2023-06-7',
                      completeDate: '2023-06-06 11:13:16',
                      masterUserName: '国融008',
                      nodeProcess: '100',
                      nodeProcessDesc: '已完成[耗时11秒]',
                      nodeState: 2,
                      processName: '新合同审核全流程0606',
                      childProcess: 0,
                      processIngdesc: '完成时间:2023-06-06'
                  },
                  {
                      nodeName: '合同审核',
                      beginDate: '2023-06-06',
                      endDate: '2023-06-07',
                      completeDate: '2023-06-06 11:13:16',
                      masterUserName: '国融008',
                      nodeProcess: '100',
                      nodeProcessDesc: '已完成[耗时29秒]',
                      nodeState: 2,
                      processName: '新合同审核全流程0606',
                      childProcess: 1,
                      processIngdesc: '完成时间:2023-06-06'
                  },
                  {
                      nodeName: '合同生效确认',
                      beginDate: '2023-06-06',
                      endDate: '2023-06-07',
                      completeDate: '2023-06-06 11:14:37',
                      masterUserName: '国融008',
                      nodeProcess: '100',
                      nodeProcessDesc: '已完成[耗时50秒]',
                      nodeState: 2,
                      processName: '新合同审核全流程0606',
                      childProcess: 0,
                      processIngdesc: '完成时间:2023-06-06'
                  },
                  {
                      nodeName: '合同归档',
                      beginDate: '2023-06-06',
                      endDate: '2023-06-09',
                      masterUserName: '国融008',
                      nodeProcess: '0',
                      nodeProcessDesc: '截止时间:2023-06-09',
                      nodeState: 1,
                      processName: '新合同审核全流程0606',
                      childProcess: 0,
                      processIngdesc: '进行中: 28%'
                  },
                  {
                      nodeName: '合同策划',
                      beginDate: '2023-06-06',
                      endDate: '2023-06-10',
                      masterUserName: '国融008',
                      nodeProcess: '0',
                      nodeProcessDesc: '截止时间:2023-06-10',
                      nodeState: 1,
                      processName: '新合同审核全流程0606',
                      childProcess: 2,
                      processIngdesc: '进行中: 83%'
                  }
              ],
              isShowApproveMaps: false,
              isShowProcessMaps: false,
              approveMapsArray: [ {
                  nodeName: '业务立项2',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-7',
                  completeDate: '2023-06-06 11:13:16',
                  masterUserName: '国融0082',
                  nodeProcess: '100',
                  nodeProcessDesc: '已完成[耗时11秒]',
                  nodeState: 2,
                  processName: '新合同审核全流程0606',
                  childProcess: 0,
                  processIngdesc: '完成时间:2023-06-06'
              },
              {
                  nodeName: '合同审核',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-07',
                  completeDate: '2023-06-06 11:13:16',
                  masterUserName: '国融008',
                  nodeProcess: '100',
                  nodeProcessDesc: '已完成[耗时29秒]',
                  nodeState: 2,
                  processName: '新合同审核全流程0606',
                  childProcess: 1,
                  processIngdesc: '完成时间:2023-06-06'
              },
              {
                  nodeName: '合同生效确认',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-07',
                  completeDate: '2023-06-06 11:14:37',
                  masterUserName: '国融008',
                  nodeProcess: '100',
                  nodeProcessDesc: '已完成[耗时50秒]',
                  nodeState: 2,
                  processName: '新合同审核全流程0606',
                  childProcess: 0,
                  processIngdesc: '完成时间:2023-06-06'
              },
              {
                  nodeName: '合同归档',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-09',
                  masterUserName: '国融008',
                  nodeProcess: '0',
                  nodeProcessDesc: '截止时间:2023-06-09',
                  nodeState: 1,
                  processName: '新合同审核全流程0606',
                  childProcess: 0,
                  processIngdesc: '进行中: 28%'
              },
              {
                  nodeName: '合同策划',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-10',
                  masterUserName: '国融008',
                  nodeProcess: '0',
                  nodeProcessDesc: '截止时间:2023-06-10',
                  nodeState: 1,
                  processName: '新合同审核全流程0606',
                  childProcess: 2,
                  processIngdesc: '进行中: 83%'
              }],
              processMapsArray: [ {
                  nodeName: '业务立项23',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-7',
                  completeDate: '2023-06-06 11:13:16',
                  masterUserName: '国融0081',
                  nodeProcess: '100',
                  nodeProcessDesc: '已完成[耗时11秒]',
                  nodeState: 2,
                  processName: '新合同审核全流程0606',
                  childProcess: 0,
                  processIngdesc: '完成时间:2023-06-06'
              },
              {
                  nodeName: '合同审核',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-07',
                  completeDate: '2023-06-06 11:13:16',
                  masterUserName: '国融008',
                  nodeProcess: '100',
                  nodeProcessDesc: '已完成[耗时29秒]',
                  nodeState: 2,
                  processName: '新合同审核全流程0606',
                  childProcess: 1,
                  processIngdesc: '完成时间:2023-06-06'
              },
              {
                  nodeName: '合同生效确认',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-07',
                  completeDate: '2023-06-06 11:14:37',
                  masterUserName: '国融008',
                  nodeProcess: '100',
                  nodeProcessDesc: '已完成[耗时50秒]',
                  nodeState: 2,
                  processName: '新合同审核全流程0606',
                  childProcess: 0,
                  processIngdesc: '完成时间:2023-06-06'
              },
              {
                  nodeName: '合同归档',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-09',
                  masterUserName: '国融008',
                  nodeProcess: '0',
                  nodeProcessDesc: '截止时间:2023-06-09',
                  nodeState: 1,
                  processName: '新合同审核全流程0606',
                  childProcess: 0,
                  processIngdesc: '进行中: 28%'
              },
              {
                  nodeName: '合同策划',
                  beginDate: '2023-06-06',
                  endDate: '2023-06-10',
                  masterUserName: '国融008',
                  nodeProcess: '0',
                  nodeProcessDesc: '截止时间:2023-06-10',
                  nodeState: 1,
                  processName: '新合同审核全流程0606',
                  childProcess: 2,
                  processIngdesc: '进行中: 83%'
              }]
          };
      },
      props: {
          processList: {
              type: Array
          }
      },
      created () {
          if (this.processList) {
              this.dataList = this.processList;
          }
      },
      methods: {
          showChildProcess (item) {
              console.log(item);
              if (item.childProcess === 1) { // 审批流
                  this.isShowApproveMaps = true;
              } else if (item.childProcess === 2) { // 业务流
                  this.isShowProcessMaps = true;
              }
          }
      }
};
</script>
<style lang="less">
.process-line-box{
    display: flex;
    .rocess-line-start{
        width: 120px;
        height: 120px;
        display: flex;
        justify-content: flex-start;   /* 左对齐 */
        flex-wrap: wrap;   /* 换行 */
        align-items: center;
        align-content: center;
        .rocess-line-start-ring{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 4px solid rgb(76, 137, 251);
        }
        // .rocess-line{
        //     flex: 1;
        //     border: 1px solid #c5bebe;
        //     background: #c5bebe;
        //     height: 1px;
        // }
         /* 整个流动箭头的body */
        .arrow-body {
            flex: 1;
            position: relative;
            margin: 0;
            padding: 0;
            /* 这里修改整个流动箭头的长度 */
            /* 这里修改body的高度，注意：会影响三角箭头的形状 */
            height: 24px;
            overflow: hidden;
            /* 流动的线条的body */
            .flow-body {
                position: relative;
                margin: 0;
                padding: 0;
                height: 100%;
                width:~"calc(100% - 10px)";
                overflow: hidden;
            }
            /* 线条样式 */
            .flow-body::before {
                content:"";
                position: absolute;
                width: 200%;
                /* 这里修改线条的高度，同时top减去的值是高度的一半（为了保持垂直居中） */
                height: 3px;
                top:~"calc(56% - 3px)";
                /* 这里修改线条的颜色（可以达到渐变） */
                background: repeating-linear-gradient(90deg,#03fcf7 0,#03fcf7 15px,rgba(0,0,0,0) 15px,rgba(0,0,0,0) 20px);
                transform: translateX(-100%);
                animation: flow linear 8s infinite;
            }
            /* 流动动画 */
            @keyframes flow {
                from {
                    transform:translateX(-50%);
                }
                to {
                    transform:translateX(0);
                }
            }
        }
        /* 三角箭头 */
        .arrow-body::after {
            content:"";
            position:absolute;
            /* 这里要和下面一起修改 */
            right: 0px;
            top: 6px ;
            width: 0;
            height: 0;
            /* 这里修改箭头的高度，这里建议是上面的24px的一半，同时要修改right：-12px的值 */
            border: 6px solid transparent;
            /* 这里可以修改箭头的横向长度，以及颜色 */
            border-left-width: 16px;
            border-left-color: #03fcf7;
        }
    }
    .rocess-line-end{
        width: 120px;
        height: 120px;
        display: flex;
        justify-content: flex-start;   /* 左对齐 */
        flex-wrap: wrap;   /* 换行 */
        align-items: center;
        align-content: center;
        margin-left: -8px;
        .rocess-line-end-ring{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 4px solid #c5bebe;
        }
    }
    .rocess-line-node{
        width: 220px;
        height: 120px;
        display: flex;
        justify-content: flex-start;   /* 左对齐 */
        flex-wrap: wrap;   /* 换行 */
        align-items: center;
        align-content: center;
        margin-left: -10px;
        .node-item{
            // width: 120px;
            .rocess-line-node-item{
                display: flex;
                .left-icon{
                    // width: 50px;
                    // height: 50px;
                    // transform: rotate(45deg);
                    // background-color : #fa783c;
                    // background-image: url("~assets/img/process/shandian.png") no-repeat;
                    z-index: 2;
                    img{
                        width: 80px;
                        height: 80px;
                        // transform: rotate(-45deg);
                        // margin-top: 6px;
                        // margin-left: 6px;
                    }
                }
                // .process-desc{
                //     height: 38px;
                //     line-height: 38px;
                //     width: 80px;
                //     border-radius: 16px;
                //     background: #1296db;
                //     color: #fff;
                //     font-size: 14px;
                //     text-align: center;
                //     z-index: 1;
                //     margin-left: -10px;
                // }
            }
            .node-master{
                height: 120px;
                border-left: 2px solid #c5bebe;
                position: absolute;
                margin-left: 24px;
                margin-top: -14px;
                padding-left: 10px;
                .tit{
                    font-size: 16px;
                    font-weight: 600;
                    height: 24px;
                    line-height: 24px;
                    margin-top: 4px;
                    .approvalProcess{
                        color: #0352fc;
                        cursor: pointer;
                        font-size: 18px;
                    }
                    .businessProcess{
                        color: #20c9c6;
                        cursor: pointer;
                        font-size: 18px;
                    }
                }
                .user{
                    display: flex;
                    margin-top: 10px;
                    .surname{
                        width: 30px;
                        height: 30px;
                        text-align: center;
                        line-height: 30px;
                        border-radius: 50%;
                        background-color: rgb(76, 137, 251);
                        color: #fff;
                        font-weight: 600;
                    }
                    .fullname{
                        color: #333;
                        margin-left: 10px;
                        // width: 30px;
                        height: 30px;
                        line-height: 30px;
                        font-size: 14px;
                    }
                }
                .processIngdesc{
                    height: 30px;
                    line-height: 30px;
                    margin-top: 10px;
                    background: #d4237a;
                    padding: 0px 10px;
                    border-radius: 6px;
                    color: #fff;
                }
                .processIng{
                    background: #1296db;
                }
                .processComplete{
                    background: #0b8e14;
                }
            }
            .node-name{
                position: absolute;
                margin-top: 100px;
                height: 40px;
                line-height: 40px;
                display: flex;
                .node-name-icon{
                    height: 40px;
                    width: 40px;
                }
                .node-name-title{
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                    color: #d4d0d0;
                    margin-left: 10px;
                }
            }
        }
        // .rocess-line{
        //     flex: 1;
        //     border: 1px solid #c5bebe;
        //     background: #c5bebe;
        //     height: 1px;
        // }
          /* 整个流动箭头的body */
          .arrow-body {
            flex: 1;
            position: relative;
            margin: 0;
            padding: 0;
            /* 这里修改整个流动箭头的长度 */
            /* 这里修改body的高度，注意：会影响三角箭头的形状 */
            height: 24px;
            overflow: hidden;
            /* 流动的线条的body */
            .flow-body {
                position: relative;
                margin: 0;
                padding: 0;
                height: 100%;
                width:~"calc(100% - 10px)";
                overflow: hidden;
            }
            /* 线条样式 */
            .flow-body::before {
                content:"";
                position: absolute;
                width: 200%;
                /* 这里修改线条的高度，同时top减去的值是高度的一半（为了保持垂直居中） */
                height: 3px;
                top:~"calc(56% - 3px)";
                /* 这里修改线条的颜色（可以达到渐变） */
                background: repeating-linear-gradient(90deg,#03fcf7 0,#03fcf7 15px,rgba(0,0,0,0) 15px,rgba(0,0,0,0) 20px);
                transform: translateX(-100%);
                animation: flow linear 8s infinite;
            }
            /* 流动动画 */
            @keyframes flow {
                from {
                transform:translateX(-50%);
                }
                to {
                transform:translateX(0);
                }
            }
        }
        /* 三角箭头 */
        .arrow-body::after {
            content:"";
            position:absolute;
            /* 这里要和下面一起修改 */
            right: 0px;
            top: 6px ;
            width: 0;
            height: 0;
            /* 这里修改箭头的高度，这里建议是上面的24px的一半，同时要修改right：-12px的值 */
            border: 6px solid transparent;
            /* 这里可以修改箭头的横向长度，以及颜色 */
            border-left-width: 16px;
            border-left-color: #03fcf7;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/VueOrgTree/ProcessMapsChild.vue